// Fields to request when fetching bowling centers
export const BC_FIELDS = [
  'uuid',
  'lanes',
  'activeGames',
  'address',
  'companyName',
  'country',
  'countryCode',
  'logoUrl',
  'viewersCurrent',
  'features',
  'location',
  'city',
  'state',
  'postalCode',
];
